import { Component } from '@angular/core';
import { EMDMICONS } from '../../../../common/constants/icon-packs.constant';
import { searchIcon } from '@progress/kendo-svg-icons';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { EmailsAuditService } from '../../service/emails-audit.services';
import { ExportService } from '../../../../common/service/export.service';
import { CommonService } from '../../../../common/service/common.service';
import { FileSaverService } from 'ngx-filesaver';
import { SortDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-emails-audit',
  standalone: false,
  templateUrl: './emails-audit.component.html',
  styleUrl: './emails-audit.component.scss'
})
export class EmailsAuditComponent {

  emailsAuditList: any = { data: [], total: 0 };
  pageSize: number = 10;
  skip = 0;
  filterObj: any = {
    MaterialName: null,
    user: null,
    startDate: null,
    endDate: null
  };

  // Date format for the datepickers
  dateFormat: string = 'yyyy-MM-dd';
  public today: Date = new Date(); // Set today's date
  searchValue: string = '';

  iconPacks = EMDMICONS;
  searchIcon = searchIcon;

  isAdvancedFilterOpened: boolean = false;

  materialNameList: any = [];
  filterMaterialNameList: any = [];
  userList: any = [];
  filterUserList: any = [];

  isAdvFilterOpened: boolean = false;
  emailsAuditListCount: any;

  constructor(
    private fileSaverService: FileSaverService,
    private emailsAuditService: EmailsAuditService, private exportService: ExportService,
    private commonService: CommonService

  ) {
    this.GetAuditEmails();
    this.GetAuditEmailUsers();
    this.GetMaterialName();
  }
  ngOnInit(): void {
    this.setDefaultDateRange();
  }

  /**
    * Sets the default date range to the last 7 days
    */
  setDefaultDateRange(): void {
    // Set end date to current date
    const endDate = new Date();

    // Set start date to 7 days ago
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    this.filterObj.startDate = startDate;
    this.filterObj.endDate = endDate;
  }

  reset() {
    this.searchValue = '';
    this.setDefaultDateRange();
    this.filterObj.MaterialName = null;
    this.filterObj.user = {};
    this.GetAuditEmails();
  }

  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;

    this.GetAuditEmails();
  }

  GetMaterialName() {
    this.emailsAuditService.GetMaterialName({}).subscribe({
      next: (data) => {
        this.materialNameList = data;
        this.filterMaterialNameList = data;
      },
      error: (err) => { }
    });
  }

  GetAuditEmailUsers() {
    this.emailsAuditService.GetAuditEmailUsers({}).subscribe({
      next: (data) => {
        this.userList = data;
        this.filterUserList = data;
      }
      ,
      error: (err) => { }
    });
  }

  changeStartDate(change: string) {
    if (this.filterObj.startDate > this.filterObj.endDate) {
      this.commonService.showNotificationMessage('End date should be later than the start date', 'error');
    }

  }
  GetAuditEmails() {

    let body = {
      "take": this.pageSize,
      "skip": this.skip,
      "searchText": this.searchValue || null,
      "materialName": this.filterObj.MaterialName || null,
      "userId": this.filterObj.user?.userId || 0,
      "startDate": this.filterObj.startDate,
      "endDate": this.filterObj.endDate // "2025-02-26T16:52:20.828Z"
    }

    if (this.filterObj.startDate) {
      let startDate = new Date(this.filterObj.startDate);
      startDate.setHours(0, 0, 0, 0);
      body.startDate = startDate.toISOString();
    }

    if (this.filterObj.endDate) {
      let endDate = new Date(this.filterObj.endDate);
      endDate.setHours(23, 59, 59, 999);
      body.endDate = endDate.toISOString();
    }
    if (!this.isAdvancedFilterOpened) {
      body = {
        "take": this.pageSize,
        "skip": this.skip,
        "searchText": this.searchValue || null,
        "materialName": null,
        "userId": 0,
        "startDate": null,
        "endDate": null // "2025-02-26T16:52:20.828Z"
      }
    }


    this.emailsAuditService.GetAuditEmails(body).subscribe({
      next: (data) => {
        this.emailsAuditList.data = data.auditEmails.map((item: any) => {

          let materialApprovedPlants = {
            ManufacturingPlants: [],
            WarehousePlants: []
          }
          let UserPlants = [];
          let removedPlants = [];

          try {
            materialApprovedPlants = JSON.parse(item.materialApprovedPlants);
          } catch (error) {
            console.error('Error parsing materialApprovedPlants JSON:', error);
          }

          try {
            removedPlants = JSON.parse(item.removedPlants);
          } catch (error) {
            console.error('Error parsing removedPlants JSON:', error);
          }

          try {
            UserPlants = JSON.parse(item.userPlants);
          } catch (error) {
            console.error('Error parsing UserPlants JSON:', error);
          }

          return {
            ...item,

            ManufacturingPlants: materialApprovedPlants.ManufacturingPlants?.map((data: any) => (data.CompositionName + `[${data.CompositionInfoRevision}] - ` + (data.PlantName || data.plantName))),
            WarehousePlants: materialApprovedPlants.WarehousePlants?.map((data: any) => (data.PlantName || data.plantName)),
            removedPlants: removedPlants?.Plant?.map((data: any) => (`${data.PlantName || data.plantName} from '${data.MaterialName}'`)),

            userPlants: UserPlants?.UserPlants?.map((data: any) => (data.PlantName || data.plantName)),
          };
        });
        this.emailsAuditList.total = data.totalCount;
      },
      error: (err) => { }
    });

  }

  

  GetAuditEmailsForExcel() {
    let body = {
      "take": this.pageSize,
      "skip": this.skip,
      "searchText": this.searchValue || null,
      "materialName": this.filterObj.MaterialName || null,
      "userId": this.filterObj.user?.userId || 0,
      "startDate": this.filterObj.startDate,
      "endDate": this.filterObj.endDate // "2025-02-26T16:52:20.828Z"
    }


    if (this.filterObj.startDate) {
      let startDate = new Date(this.filterObj.startDate);
      startDate.setHours(0, 0, 0, 0);
      body.startDate = startDate.toISOString();
    }

    if (this.filterObj.endDate) {
      let endDate = new Date(this.filterObj.endDate);
      endDate.setHours(23, 59, 59, 999);
      body.endDate = endDate.toISOString();
    }


    if (!this.isAdvancedFilterOpened) {
      body = {
        "take": 1000,
        "skip": 0,
        "searchText": this.searchValue || null,
        "materialName": null,
        "userId": 0,
        "startDate": null,
        "endDate": null // "2025-02-26T16:52:20.828Z"
      }
    }
    this.emailsAuditService.GetAuditEmailsForExcel(body).subscribe({
      next: (fileData) => {
        this.fileSaverService.save(fileData, 'AuditEmails.xlsx');
      },
      error: (err) => { }
    });

  }
  downloadFile(data: any) {

    let exportColoumns = ['Material', 'Approved Plants', 'User Plants', 'User', 'Email sent on'];

    let exportData = data.map((data: any) => {
      return {
        material: data.materialName,
        approvedPlants: data.materialApprovedPlants,
        userPlants: data.userPlants,
        user: data.userName,
        emailSentOn: data.materialLoggedDateTime
      }
    });

    let custName = "export_emails_audit_" + new Date().toISOString().slice(0, 10) + ".xlsx";

    this.exportService.exportExcel(exportData, [exportColoumns], custName)
  }

  handleMaterialFilter(value: any) {

    this.filterMaterialNameList = this.materialNameList.filter(
      (s: any) => {
        return s.toLowerCase().indexOf(value.toLowerCase()) !== -1
      }
    );
  }

  handleUserFilter(value: any) {
    this.filterUserList = this.userList.filter(
      (s: any) => {
        return s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
      }
    );
  }

  sort: SortDescriptor[] = [];

  sortChange(event: any) {
    let tmpSort: any = [];
    if (event[0].dir) {
      this.sort = event;
      tmpSort = event
    }
    else {
      this.sort = [];
      tmpSort = [{ field: 'id', dir: 'desc' }]
    }
    this.sort = event;

    this.emailsAuditList.data = this.emailsAuditList.data.sort((a: any, b: any) => {
      let result = 0;
      tmpSort.forEach((sortDescriptor: any) => {
        let key: string = sortDescriptor.field;
        if (result === 0) {
          // date sorting
          if (['materialLoggedDateTime'].includes(key)) {
            result = this.compareDates(a[sortDescriptor.field], b[sortDescriptor.field], sortDescriptor.dir);
          } else {
            result = this.compareValues(a[sortDescriptor.field], b[sortDescriptor.field], sortDescriptor.dir);
          }
        }
      });
      return result;
    });

  }
  compareDates(a: any, b: any, order: string) {
    if (!a || !b) {
      return 0;
    }
    if (order === 'asc') {
      return new Date(a) > new Date(b) ? 1 : new Date(a) < new Date(b) ? -1 : 0;
    } else {
      return new Date(a) < new Date(b) ? 1 : new Date(a) > new Date(b) ? -1 : 0;
    }
  }
  compareValues(a: any, b: any, order: string) {
    if (!a || !b) {
      return 0;
    }
    if (order === 'asc') {
      return a > b ? 1 : a < b ? -1 : 0;
    } else {
      return a < b ? 1 : a > b ? -1 : 0;
    }
  }
}
